const location = {
  assign: (url) => {
    window.location.assign(url);
  },
  replace: (url) => {
    window.location.replace(url);
  },
};

const getInnerHeight = () => window.innerHeight;

export { location, getInnerHeight };
